import { SocketData } from 'actions/socket/socketReceiveDataAction'
import {
  ChatMessengerState,
  MessageTypingFromCometContent,
} from 'reducers/messenger/ChatMessengerState'

export const addTypingSignal = (
  typingMessages: SocketData<MessageTypingFromCometContent>,
  chatState: ChatMessengerState
): ChatMessengerState => {
  const content = typingMessages.content

  /**
   * Пользователь выбранного чата, не стал пока приводить к общему виду.
   */
  if (content.senderId === chatState.selectedProfileId && !chatState.isTyping) {
    return {
      ...chatState,
      isTyping: true,
    }
  }

  if (content.senderId !== chatState.typingUser) {
    return {
      ...chatState,
      typingUser: content.senderId,
    }
  }

  return chatState
}
